import React, { isValidElement, ReactElement, ReactNode } from 'react'
import { isString } from 'lodash'
import { toastr } from 'react-redux-toastr'
import { ToastrContent } from 'components/toastr/ToastrContent'
import { ToastrType } from 'types/toastr'

type MessageParams = ReactElement | string

const toastrDefaultOptions = {
  timeOut: 3000,
  position: 'bottom-right',
  transitionIn: 'fadeIn',
  transitionOut: 'fadeOut',
  removeOnHover: true,
}

interface ToastrParams {
  type?: ToastrType
  message?: ReactNode
  buttons?: ReactElement | ReactElement[]
  subItem?: string | ReactElement
  hasIcon?: boolean
  customIconName?: string
  toastrOptions?: any
}

const showToastr = (params: ToastrParams) => {
  const { type, message, buttons, subItem, hasIcon, customIconName, toastrOptions = {} } = params

  /* eslint-disable */
  toastr.message('', {
    ...toastrDefaultOptions,
    ...toastrOptions,
    component: (
      <ToastrContent
        type={type}
        message={message}
        hasIcon={hasIcon}
        customIconName={customIconName}
        buttons={buttons}
        subItem={subItem}
      />
    ),
  })
  /* eslint-enable */
}

/**
 * This method is used in cases where toast is a single string:
 *
 * @example
 *
 * Toastr.success('Some toast message!')
 * Toastr.success(<span>Some <b>toast</b> message</span>)
 */
const transformParamsIfSingleArgument = (params: MessageParams) =>
  isString(params) || isValidElement(params) ? { message: params } : params

export const Toastr = {
  success: (params: MessageParams) => {
    showToastr({ ...transformParamsIfSingleArgument(params), type: 'success' })
  },

  error: (params: MessageParams) => {
    showToastr({
      message: 'Something went wrong. Please try again later',
      ...transformParamsIfSingleArgument(params),
      type: 'error',
    })
  },

  warning: (params: MessageParams) => {
    showToastr({ ...transformParamsIfSingleArgument(params), type: 'warning' })
  },

  info: (params: MessageParams) => {
    showToastr({ ...transformParamsIfSingleArgument(params), type: 'info' })
  },

  message: (params: MessageParams) => {
    showToastr({ ...transformParamsIfSingleArgument(params), type: 'info', hasIcon: false })
  },
}
